import React from 'react';
import '../../App.scss'
import './cta.scss';

const CTA = () => {
    return (
        <section className='gpt3__cta' id='cta'>
            <div className='gpt3__cta-content'>

                <p>Request Early Access to Get Started</p>

                <h3>Register today & start exploring the endless possiblities.</h3>
            </div>

            <div className='gpt3__cta-button'>
                <button type="button" className='btn__black'>Get Started</button>
            </div>
        </section>
    )
}

export default CTA